// utils/exportExpensesToExcel.js
import * as XLSX from "xlsx";

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return Number.isNaN(date.getTime())
    ? ""
    : date.toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
};

const formatCurrency = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};

export const exportExpensesToExcel = (expenses, fileName = "expenses") => {
  if (!expenses?.length) {
    console.warn("No expenses to export");
    return;
  }

  const rows = expenses.map((e) => ({
    "Expense #": e.expenseNumber || "",
    "Receipt #": e.reference || "",
    Description: e.description || "",
    Type: e.type || "",
    Category: e.categoryName || "",
    Status: e.status || "",
    Amount: formatCurrency(e.amount),
    "Bank Commission": formatCurrency(e.bankCommission),
    "Excise Amount": formatCurrency(e.exciseAmount),
    "Tax Amount": formatCurrency(e.vatAmount),
    "Withholding Amount": formatCurrency(e.withholdingAmount),
    "Payment Date": formatDate(e.date),
    "Created At": formatDate(e.createdAt),
    Branch: e.branchName || "",
    "Payment Method": e.paymentMethod || "",
    "Approved By": (e.approvedBy || "").trim(),
    Supplier: e.partnerName || "",
    TIN: e.partnerTin || "",
  }));

  const worksheet = XLSX.utils.json_to_sheet(rows);

  // Apply numeric formatting to monetary columns.
  const moneyColumns = [
    "Amount",
    "Bank Commission",
    "Excise Amount",
    "Tax Amount",
    "Withholding Amount",
  ];

  const headers = Object.keys(rows[0]);
  const range = XLSX.utils.decode_range(worksheet["!ref"]);

  moneyColumns.forEach((column) => {
    const colIndex = headers.indexOf(column);

    for (let row = 1; row <= range.e.r; row++) {
      const address = XLSX.utils.encode_cell({
        r: row,
        c: colIndex,
      });

      const cell = worksheet[address];

      if (cell) {
        cell.t = "n";
        cell.z = "#,##0.00";
      }
    }
  });

  worksheet["!cols"] = headers.map((key) => ({
    wch: Math.max(key.trim().length, 14),
  }));

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Expenses");

  const timestamp = new Date().toISOString().slice(0, 10);
  XLSX.writeFile(workbook, `${fileName}_${timestamp}.xlsx`);
};
